import React from 'react'
import PropTypes from 'prop-types'

const AdminItem = ({ children, dbRef, param, itemTitle, remove, edit }) => (
  <li className="box level admin-item">
    {children}
    <div className="field is-grouped">
      <div className="control">
        <a onClick={() => edit(dbRef, param)} className="button is-info">
          Edit
        </a>
      </div>
      {remove && (
        <div className="control">
          <a onClick={() => remove(dbRef, param, itemTitle)} className="button is-danger">
            Delete
          </a>
        </div>
      )}
    </div>
  </li>
)
export default AdminItem

AdminItem.propTypes = {
  edit: PropTypes.func.isRequired,
  remove: PropTypes.func,
  itemTitle: PropTypes.string,
  dbRef: PropTypes.object.isRequired,
  param: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminItem.js